export default function Badge() {
  return {
    MuiBadge: {
      styleOverrides: {
        colorWarning: {
          color: '#fff',
          fontWeight: 500,
        },
      },
    },
  };
}
